import { useState } from "react";
import { Button, Message, Modal, Progress } from "semantic-ui-react";
import { startLongTimeDownload } from "../../http";
import { openDownloadDialog } from "../../utils";


type Status = 'start' | 'doing' | 'done' | 'error';
type DownloaderProps = { isOpen: boolean, status: Status, message: string, progressPercent: number, onClose: () => void, start: () => void }
export function useLongTimeDownload(path: string, body: () => any, method: 'post' | 'get' | 'delete' | 'put'): DownloaderProps {
    const sStatus = useState<Status>('start');
    const sMessage = useState('Starting...');
    const sPercent = useState(0);
    const sIsOpen = useState(false);

    const start = () => {
        sStatus[1]('doing');
        sPercent[1](0);
        sIsOpen[1](true);
        startLongTimeDownload(path, body(), method, (type, message) => {
            sStatus[1](type);
            sMessage[1](message);
        }, (fileName, data) => {
            openDownloadDialog(data, fileName);
            sIsOpen[1](false);
        }, percent => sPercent[1](percent));
    }

    return { isOpen: sIsOpen[0], status: sStatus[0], message: sMessage[0], progressPercent: sPercent[0], onClose: () => sIsOpen[1](false), start }
}

export function LongTimeDownloader(props: Omit<DownloaderProps, 'start'>) {
    return <Modal open={props.isOpen} closeOnEscape={false}
        closeOnDimmerClick={false}>
        <Modal.Header>Download</Modal.Header>
        <Modal.Content>
            <Message error={props.status == 'error'}>
                {props.message}
            </Message>

            <>{props.progressPercent > 0 && <Progress color="blue" percent={props.progressPercent}></Progress>}</>
        </Modal.Content>

        {props.status == 'error' && <Modal.Actions>
            <Button onClick={e => {
                e.preventDefault();
                e.stopPropagation();

                props.onClose();
            }}>Close</Button>
        </Modal.Actions>}
    </Modal>
}